<template>
    <toolbar-option>
        <template slot="primary">
            <button-group
                :value="value"
                :options="options"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'calendar-facet-title-alignment',
    mixins: [baseOption],

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            displayName: 'Title Alignment',
            tailwindDefinitionProp: 'textAlign',
        };
    },

    methods: {
        onInput(valueNew) {
            this.onOptionChange(valueNew);
            this.$emit('input', valueNew);
        },
    },
};
</script>
